
import galary11 from '../images/babaPreacing.jpeg'
import galary12 from '../images/congregation.jpeg'
import galary13 from '../images/congregationListening.jpeg'
import galary14 from '../images/congregationSiting.jpeg'
import galary15 from '../images/congregationSiting1.jpeg'

import galary16 from '../images/offeringTime.jpeg'
import galary17 from '../images/peoplePraying.jpeg'
import galary18 from '../images/peoplePraying1.jpeg'

import galary19 from '../images/peopleWaiting.jpeg'
import galary20 from '../images/praiseSession.jpeg'

export const Data =[
//     {
//         img:`${galary0}`
//     },
//    {
//      img:`${galary1}`
//     },
//     {
//       img:`${galary2}`
//     },
//     {
//       img:`${galary3}`
//     },
//     {
//       img:`${galary4}`
//     },
//     {
//       img:`${galary5}`
//     },
//     {
//       img:`${galary6}`
//     },
//     {
      
//       img:`${galary7}`
//     },
//     {
      
//       img:`${galary8}`
//     },
//     {  
//       img:`${galary9}`
//     },
//     {  
//       img:`${galary10}`
//     },
    {
      img:`${galary11}`
    },
    {
      img:`${galary12}`
    },
    {
      img:`${galary13}`
    },
    {
      img:`${galary14}`
    },
    {
      img:`${galary15}`
    },  
    {
        img:`${galary16}`
    },
    {
    img:`${galary17}`
    },
    {
    img:`${galary18}`
    },
    {
    img:`${galary19}`
    },
    {
    img:`${galary20}`
    }
]